import React from "react";
import { connect } from "alt-react";
import classNames from "classnames";
import AccountActions from "actions/AccountActions";
import AccountStore from "stores/AccountStore";
import AccountNameInput from "./../Forms/AccountNameInput";
import WalletDb from "stores/WalletDb";
import { Link } from "react-router-dom";
import AccountSelect from "../Forms/AccountSelect";
import TransactionConfirmStore from "stores/TransactionConfirmStore";
import LoadingIndicator from "../LoadingIndicator";
import Translate from "react-translate-component";
import counterpart from "counterpart";
import { ChainStore, FetchChain, key } from "bitsharesjs";
import ReactTooltip from "react-tooltip";
import utils from "common/utils";
import SettingsActions from "actions/SettingsActions";
import WalletUnlockActions from "actions/WalletUnlockActions";
import Icon from "../Icon/Icon";
import CopyButton from "../Utility/CopyButton";
import { withRouter } from "react-router-dom";
import { scroller } from "react-scroll";
import { Notification, Tooltip } from "bitshares-ui-style-guide";
import PasswordInput from "./../Forms/PasswordInput";

class CreateAccountPassword extends React.Component {
  constructor() {
    super();
    this.state = {
      validAccountName: false,
      accountName: "",
      validPassword: false,
      registrar_account: null,
      loading: false,
      hide_refcode: true,
      show_identicon: false,
      step: 1,
      showPass: false,
      generatedPassword: ("P" + key.get_random_key().toWif()).substr(0, 45),
      password: "",
      confirm_password: "",
      understand_1: false,
      understand_2: false,
      understand_3: false,
      passwordVisible: false,
      passwordInputVisible: false,
      passwordInputValid: false
    };
    this.onFinishConfirm = this.onFinishConfirm.bind(this);
    this.accountNameInput = null;
    this.scrollToInput = this.scrollToInput.bind(this);
  }

  UNSAFE_componentWillMount() {
    if (!WalletDb.getWallet()) {
      SettingsActions.changeSetting({
        setting: "passwordLogin",
        value: true
      });
    }
  }

  componentDidMount() {
    ReactTooltip.rebuild();
    this.scrollToInput();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !utils.are_equal_shallow(nextState, this.state);
  }

  scrollToInput() {
    scroller.scrollTo(`scrollToInput`, {
      duration: 1500,
      delay: 100,
      smooth: true,
      containerId: "accountForm"
    });
  }

  isValid() {
    let firstAccount = AccountStore.getMyAccounts().length === 0;
    let valid = this.state.validAccountName;

    if (!WalletDb.getWallet()) {
      valid = valid && this.state.validPassword;
    }

    if (!firstAccount) {
      valid = valid && this.state.registrar_account;
    }

    return valid && this.state.passwordInputValid && this.state.understand_1 && this.state.understand_2;
  }

  onAccountNameChange(e) {
    const state = {};
    if (e.valid !== undefined) state.validAccountName = e.valid;
    if (e.value !== undefined) state.accountName = e.value;
    if (!this.state.show_identicon) state.show_identicon = true;
    this.setState(state);
  }

  onFinishConfirm(confirm_store_state) {
    if (confirm_store_state.included && confirm_store_state.broadcasted_transaction) {
      TransactionConfirmStore.unlisten(this.onFinishConfirm);
      TransactionConfirmStore.reset();
      FetchChain("getAccount", this.state.accountName, undefined, {
        [this.state.accountName]: true
      }).then(() => {
        this.props.history.push("/wallet/backup/create?newAccount=true");
      });
    }
  }

  _unlockAccount(name, password) {
    SettingsActions.changeSetting({
      setting: "passwordLogin",
      value: true
    });
    WalletDb.validatePassword(password, true, name);
    WalletUnlockActions.checkLock.defer();
  }

  createAccount(name, password) {
    let refcode = this.refs.refcode ? this.refs.refcode.value() : null;
    let referralAccount = AccountStore.getState().referralAccount;
    this.setState({
      loading: true
    });
    AccountActions.createAccountWithPassword(name, password, this.state.registrar_account, referralAccount || this.state.registrar_account, 0, refcode).then(() => {
      AccountActions.setPasswordAccount(name); // User registering his own account

      if (this.state.registrar_account) {
        FetchChain("getAccount", name, undefined, {
          [name]: true
        }).then(() => {
          this.setState({
            step: 2,
            loading: false
          });

          this._unlockAccount(name, password);
        });
        TransactionConfirmStore.listen(this.onFinishConfirm);
      } else {
        // Account registered by the faucet
        FetchChain("getAccount", name, undefined, {
          [name]: true
        }).then(() => {
          this.setState({
            step: 2
          });

          this._unlockAccount(name, password);
        });
      }
    }).catch(error => {
      console.log("ERROR AccountActions.createAccount", error);
      let error_msg = error.base && error.base.length && error.base.length > 0 ? error.base[0] : "unknown error";
      if (error.remote_ip) error_msg = error.remote_ip[0];
      Notification.error({
        message: counterpart.translate("notifications.account_create_failure", {
          account_name: name,
          error_msg: error_msg
        })
      });
      this.setState({
        loading: false
      });
    });
  }

  onSubmit(e) {
    e.preventDefault();
    if (!this.isValid()) return;
    let account_name = this.accountNameInput.getValue(); // if (WalletDb.getWallet()) {
    //     this.createAccount(account_name);
    // } else {

    this.createAccount(account_name, this.state.password);
  }

  onRegistrarAccountChange(registrar_account) {
    this.setState({
      registrar_account
    });
  } // showRefcodeInput(e) {
  //     e.preventDefault();
  //     this.setState({hide_refcode: false});
  // }


  _onInput(value, e) {
    this.setState({
      [value]: value === "confirm_password" ? e.target.value : !this.state[value],
      validPassword: value === "confirm_password" ? e.target.value === this.state.password : this.state.validPassword
    });
  }

  renderPasswordEye() {
    const {
      passwordVisible
    } = this.state;
    return !passwordVisible ? /*#__PURE__*/React.createElement("span", {
      className: "input-password-eye",
      onClick: () => this.setState({
        passwordVisible: true
      })
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "eye",
      className: "eye-icon icon-opacity"
    })) : /*#__PURE__*/React.createElement("span", {
      className: "input-password-eye",
      onClick: () => this.setState({
        passwordVisible: false
      })
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "eye-striked",
      className: "eye-icon icon-opacity"
    }));
  }

  _renderAccountCreateForm() {
    let {
      registrar_account
    } = this.state;
    let my_accounts = AccountStore.getMyAccounts();
    let firstAccount = my_accounts.length === 0;
    let valid = this.isValid();
    let isLTM = false;
    let registrar = registrar_account ? ChainStore.getAccount(registrar_account) : null;

    if (registrar) {
      if (registrar.get("lifetime_referrer") == registrar.get("id")) {
        isLTM = true;
      }
    }

    let buttonClass = classNames("submit-button button no-margin", {
      disabled: !valid || registrar_account && !isLTM
    });
    return /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: "left"
      }
    }, /*#__PURE__*/React.createElement("form", {
      style: {
        maxWidth: "60rem"
      },
      onSubmit: this.onSubmit.bind(this),
      noValidate: true
    }, /*#__PURE__*/React.createElement(AccountNameInput, {
      ref: ref => {
        if (ref) {
          this.accountNameInput = ref.refs.nameInput;
        }
      },
      cheapNameOnly: !!firstAccount,
      onChange: this.onAccountNameChange.bind(this),
      accountShouldNotExist: true,
      placeholder: counterpart.translate("wallet.account_public"),
      noLabel: true
    }), /*#__PURE__*/React.createElement("section", {
      className: "form-group"
    }, /*#__PURE__*/React.createElement("label", {
      className: "left-label"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.generated"
    }), "\xA0\xA0", /*#__PURE__*/React.createElement(Tooltip, {
      title: /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: counterpart.translate("tooltip.generate")
        }
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "tooltip"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "question-circle",
      title: "icons.question_circle"
    })))), /*#__PURE__*/React.createElement("div", {
      style: {
        paddingBottom: "0.5rem"
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "inline-label"
    }, /*#__PURE__*/React.createElement("textarea", {
      style: {
        padding: "0px",
        marginBottom: "0px"
      },
      rows: "3",
      readOnly: true,
      disabled: true,
      value: this.state.generatedPassword
    }), /*#__PURE__*/React.createElement(CopyButton, {
      text: this.state.generatedPassword,
      tip: "tooltip.copy_password",
      dataPlace: "top"
    })))), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(PasswordInput, {
      ref: "password",
      visible: this.state.passwordInputVisible,
      confirmation: false,
      value: this.state.password,
      onChange: state => this.setState({
        passwordInputValid: state.valid,
        password: state.value,
        passwordInputVisible: state.visible
      }),
      noLabel: true,
      passwordLength: 12,
      checkStrength: true
    })), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("label", {
      className: "left-label"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.confirm_password"
    })), /*#__PURE__*/React.createElement("input", {
      type: !this.state.passwordVisible ? "password" : "text",
      name: "password",
      id: "password",
      value: this.state.confirm_password,
      onChange: this._onInput.bind(this, "confirm_password")
    }), this.renderPasswordEye(), this.state.confirm_password && this.state.confirm_password !== this.state.password ? /*#__PURE__*/React.createElement("div", {
      className: "has-error"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.confirm_error"
    })) : null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: "confirm-checks",
      onClick: this._onInput.bind(this, "understand_3")
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: "checkbox-1",
      style: {
        position: "relative"
      }
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: "checkbox-1",
      onChange: () => {},
      checked: this.state.understand_3,
      style: {
        position: "absolute",
        top: "-5px",
        left: "0"
      }
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        paddingLeft: "30px"
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.understand_3"
    })))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: "confirm-checks",
      onClick: this._onInput.bind(this, "understand_1")
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: "checkbox-2",
      style: {
        position: "relative"
      }
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: "checkbox-2",
      onChange: () => {},
      checked: this.state.understand_1,
      style: {
        position: "absolute",
        top: "-5px",
        left: "0"
      }
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        paddingLeft: "30px"
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.understand_1"
    })))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: "confirm-checks",
      style: {
        paddingBottom: "1.5rem"
      },
      onClick: this._onInput.bind(this, "understand_2")
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: "checkbox-3",
      style: {
        position: "relative"
      }
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: "checkbox-3",
      onChange: () => {},
      checked: this.state.understand_2,
      style: {
        position: "absolute",
        top: "-5px",
        left: "0"
      }
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        paddingLeft: "30px"
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.understand_2"
    })))), firstAccount ? null : /*#__PURE__*/React.createElement("div", {
      className: "full-width-content form-group no-overflow",
      style: {
        paddingTop: 30
      }
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Translate, {
      content: "account.pay_from"
    })), /*#__PURE__*/React.createElement(AccountSelect, {
      account_names: my_accounts,
      onChange: this.onRegistrarAccountChange.bind(this)
    }), registrar_account && !isLTM ? /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: "left"
      },
      className: "facolor-error"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.must_be_ltm"
    })) : null), this.state.loading ? /*#__PURE__*/React.createElement(LoadingIndicator, {
      type: "three-bounce"
    }) : /*#__PURE__*/React.createElement("button", {
      style: {
        width: "100%"
      },
      className: buttonClass
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "account.create_account"
    }))));
  }

  _renderAccountCreateText() {
    let my_accounts = AccountStore.getMyAccounts();
    let firstAccount = my_accounts.length === 0;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
      style: {
        fontWeight: "normal",
        fontFamily: "Roboto-Medium, arial, sans-serif",
        fontStyle: "normal",
        paddingBottom: 15
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.wallet_password"
    })), /*#__PURE__*/React.createElement(Translate, {
      style: {
        textAlign: "left"
      },
      unsafe: true,
      component: "p",
      content: "wallet.create_account_password_text"
    }), /*#__PURE__*/React.createElement(Translate, {
      style: {
        textAlign: "left"
      },
      component: "p",
      content: "wallet.create_account_text"
    }), firstAccount ? null : /*#__PURE__*/React.createElement(Translate, {
      style: {
        textAlign: "left"
      },
      component: "p",
      content: "wallet.not_first_account"
    }));
  }

  _renderBackup() {
    return /*#__PURE__*/React.createElement("div", {
      className: "backup-submit"
    }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Translate, {
      unsafe: true,
      content: "wallet.password_crucial"
    })), /*#__PURE__*/React.createElement("div", null, !this.state.showPass ? /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        this.setState({
          showPass: true
        });
      },
      className: "button"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.password_show"
    })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", null, /*#__PURE__*/React.createElement(Translate, {
      content: "settings.password"
    }), ":"), /*#__PURE__*/React.createElement("p", {
      style: {
        fontWeight: "normal",
        fontFamily: "Roboto-Medium, arial, sans-serif",
        fontStyle: "normal",
        textAlign: "center"
      }
    }, this.state.password))), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("p", {
      className: "txtlabel warning"
    }, /*#__PURE__*/React.createElement(Translate, {
      unsafe: true,
      content: "wallet.password_lose_warning"
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        width: "100%"
      },
      onClick: () => {
        this.props.history.push("/");
      },
      className: "button"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.ok_done"
    })));
  }

  _renderGetStarted() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("table", {
      className: "table"
    }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.tips_dashboard"
    }), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
      to: "/"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "header.dashboard"
    })))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.tips_account"
    }), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
      to: `/account/${this.state.accountName}/overview`
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.link_account"
    })))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.tips_deposit"
    }), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
      to: "/deposit-withdraw"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.link_deposit"
    })))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.tips_transfer"
    }), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
      to: "/transfer"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.link_transfer"
    })))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.tips_settings"
    }), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
      to: "/settings"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "header.settings"
    })))))));
  }

  _renderGetStartedText() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      style: {
        fontWeight: "normal",
        fontFamily: "Roboto-Medium, arial, sans-serif",
        fontStyle: "normal"
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.congrat"
    })), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.tips_explore_pass"
    })), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.tips_header"
    })), /*#__PURE__*/React.createElement("p", {
      className: "txtlabel warning"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.tips_login"
    })));
  }

  render() {
    let {
      step
    } = this.state; // let my_accounts = AccountStore.getMyAccounts();
    // let firstAccount = my_accounts.length === 0;

    return /*#__PURE__*/React.createElement("div", {
      className: "sub-content",
      id: "scrollToInput",
      name: "scrollToInput"
    }, /*#__PURE__*/React.createElement("div", null, step === 2 ? /*#__PURE__*/React.createElement("p", {
      style: {
        fontWeight: "normal",
        fontFamily: "Roboto-Medium, arial, sans-serif",
        fontStyle: "normal"
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.step_" + step
    })) : null, step === 3 ? this._renderGetStartedText() : null, step === 1 ? /*#__PURE__*/React.createElement("div", null, this._renderAccountCreateForm()) : step === 2 ? this._renderBackup() : this._renderGetStarted()));
  }

}

CreateAccountPassword = withRouter(CreateAccountPassword);
export default connect(CreateAccountPassword, {
  listenTo() {
    return [AccountStore];
  },

  getProps() {
    return {};
  }

});